import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export function accountMenuLabel(account) {
  const alias = account.alias || account.display_name || account.name || "Konto";
  const balance =
    account.current_balance != null
      ? Number(account.current_balance).toLocaleString("da-DK", {
          style: "currency",
          currency: account.currency || "DKK",
        })
      : "–";
  const pending = Number(account.pending_balance || 0);
  if (!pending) return `${alias} [${balance}]`;
  const pendingLabel = pending.toLocaleString("da-DK", {
    style: "currency",
    currency: account.currency || "DKK",
  });
  return `${alias} [${balance}, inkl. ${pendingLabel} afventende]`;
}

export default function AccountSelect({
  accounts = [],
  value,
  onChange,
  label = "Konto",
  allowEmpty = false,
  emptyLabel = "Global",
  showTotal = false,
  disabled = false,
  size = "small",
  sx,
}) {
  return (
    <FormControl
      size={size}
      sx={sx}
      disabled={disabled || (!allowEmpty && !showTotal && !accounts.length)}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
      >
        {showTotal ? <MenuItem value="total">Total</MenuItem> : null}
        {allowEmpty ? <MenuItem value="">{emptyLabel}</MenuItem> : null}
        {accounts.map((account) => (
          <MenuItem key={account.account_uuid} value={account.account_uuid}>
            {accountMenuLabel(account)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
